/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getID } from "src/libs/utilities"
import { IDelimiterEdge } from "./Edge1"

export default function Edge3 (props: IDelimiterEdge): JSX.Element {
	const [id, ] = useState<ID>( getID("edge") )
		useEffect(() => {
			addCSSClass(
				`edge-${id}`,
				`.edge-${id} {
					${
						!!props.item.position
							?
							`width: ${getCssDemention(props.item.position?.width, "calc(100% + 120px)")}!important;
							min-width: 700px!important;
							height: ${getCssDemention(props.item.position?.height, "auto")}!important;
							z-index: ${ props.item.position.z || 1 }!important;
							transform: translateX(${getCssDemention(props.item.position?.left, "-60px")})  translateY(${getCssDemention(props.item.position.top, "0")}) rotate(${ props.item.position.rotate|| 0 }deg) scale(${props.item.position.scale || 1})!important;
							pointer-events: none;
							`
							:
							`
							pointer-events: none;
							`
					}
				}`
			)
			return () => {
				removeCSSClass(`edge-${id}`)
			}
		},[])
	return <svg 
		version="1.1" 
		xmlns="http://www.w3.org/2000/svg" 
		xmlnsXlink="http://www.w3.org/1999/xlink" 
		x="0px" 
		y="0px" 
		viewBox="0 0 500 48.9" 
		xmlSpace="preserve"
		className={`landing-delimiter-torn edge-${id} delimiter-edge-3`}
	>
		<path fill={props.item.fill || "var(--main-bg-color)"} d="M500.2,9.2c-1.4,0.1-2.8,0.2-4.3,0.3c-1.6,0.1-3.6-0.7-5-0.3c-0.7,0.2-1.3,1.4-2.1,1.2c-0.4-0.1-0.4-0.8-0.7-0.9
			c-1.7-0.4-2.1,0.9-3.7,0.6c-0.9-0.2-2.8-1.2-3.5-1.6c-1.2-0.7-1.2-1.8-2.2-2.5c-0.8-0.5-2-0.4-2.8-1.1c-0.5-0.5-0.4-0.9-1.2-1.3
			c-1.1-0.5-2.4-0.5-3.4,0.3c-0.6,0.5-0.4,0.9-1.2,1.1c-0.9,0.3-1.6-0.6-2.4-0.4c-0.3,0.1-1.1,0.9-1.4,1.1c-0.9,0.8-0.8,0.9-1.8,0.9
			c-0.3,0-0.4-0.5-0.8-0.5c-0.4,0-0.8,0.4-1.2,0.4c-1.7,0-2.1,0.1-3.7,1.1c-0.3,0.1-1.6,0.8-1.7,0.8c-0.4,0.5,0.1,0.9-0.2,1.3
			c-0.3,0.4-1.1,0.6-1.5,1.1c-0.3,0.4-0.4,1-0.7,1.4c-0.8-0.5-1.9-1.1-2.9-1.4c-1.6-0.5-2.4,0.2-3.8,0.2c-0.6,0-0.7-0.5-1.4-0.4
			c-0.6,0-1.3,0.7-2,0.8c-0.6,0.1-1.1-0.1-1.7,0c-0.6,0.1-0.8,0.6-1.4,0.7c-0.8,0.1-2-0.2-2.6-0.6c-0.4-0.3-0.4-1.2-1-1.3
			c-0.6-0.1-1.2,0.7-1.8,0.8c-0.7,0.2-1.3,0-2,0.1c-2.6,0.4-2.3,0.4-4.1-1.2c-0.7-0.6-2.3-1.6-3.4-2c-1.2-0.4-3.8,0-2.7-2
			c-2.3-0.4-1-1.2-1.4-2.6c-0.5-1.7-2.3-0.1-3.7,0c-0.9,0.1-2.1,0.5-3,0.5c-1.3,0-2.1-0.8-3.5-0.5c-0.7,0.1-1,0.3-1.8,0.3
			c-0.8,0-1.2-0.4-2-0.1c-1.4,0.5-2.1,1.6-3.8,1.9c-0.7,0.1-0.9,0-1.6,0.2c-0.6,0.2-1.1,0.5-1.7,0.7c-0.9,0.3-1.7,1.1-2.5,1.4
			c-1.1,0.4-1.8,0-2.8,0.6c-0.8,0.5-1.1,1.5-1.6,2.1c-0.6,0.8-0.7,0.7-2.3,1.2c-1.3,0.5-1.3,0.2-2.2,0.5c-0.7,0.2-1.3,0.9-2,1
			c-1.2,0.1-2-0.9-3.1-0.9c-1.5,0-1.5,1.1-2.8,0.5c-0.4-0.2-0.2-0.9-0.8-1c-0.3-0.1-2.2,0.5-2.5,0.6c-1.2,0.5-0.8,1-1.8,2
			c-0.2,0.2-1,0.3-1.3,0.5c-0.6,0.4-0.9,1.1-1.3,1.5c-1.6,1.7-2.4,2-4.8,2.5c-1.4,0.3-2.6,0.2-4,0.5c-1,0.2-2.6,0.1-3.4,0.4
			c-0.8,0.3-0.8,1-1.8,1c-0.5,0-0.8-0.6-1.3-0.6c-0.6,0-1,0.5-1.5,0.6c-0.6,0.1-1.4-0.3-1.9-0.2c-0.6,0.1-0.9,0.9-1.6,1
			c-1.2,0.1-0.7-0.6-1.5-1c-1.1-0.5-2.4,0.5-3.6-0.1c-0.6-0.3-0.9-1-1.3-1.4c-0.1-0.1-0.5,0-0.7-0.1c-0.4-0.4-0.7-0.9-1.1-1.2
			c-1.1,0.5-1.9-1.3-2.9-1.7c0.1-0.2,0-0.4,0.1-0.6c-1.6-0.8-3.9,0-5.3,0.8c-0.8,0.5-1.3,1.5-2.5,1.3c-0.6-0.1-0.8-0.8-1.6-0.9
			c-0.2,0.9-0.7,0.6-1.3,0.9c-0.3,0.2-0.8,0.2-1.1,0.4c-0.2,0.1-0.1,0.7-0.4,0.9c-0.4,0.2-0.8,0.1-1.2,0.3c-0.1,0-1.3,0.6-1.4,0.6
			c-0.8,0.2-1.7,0.1-2.6,0.3c0-0.2-0.3-0.6-0.3-0.8c-1.5,0.6-2.4,0.8-4,0.6c-0.2,0.9-1.8,1.1-2.6,0.7c-1.1-0.6-1-2.4-1.2-3.3
			c-1.2-0.2-1.7,1.1-2.8,1.5c-1.9,0.7-3.9,0.2-6,1.4c-0.9,0.5-0.9,1.2-1.4,1.7c-0.6,0.5-1.1,0.3-1.9,0.6c-0.6-0.6-0.6-0.1-1.2-0.1
			c-0.7,0.1-1.2,0.3-2.1,0.2c-1.2-0.1-2.7,0.3-3.5-0.8c-1,0.8-2-0.5-2.8,1c-2-1.3-3-1.9-4.9-0.4c-0.2,0.1-0.3,0.7-0.5,0.9
			c-0.1,0.1-1.1,0.5-1.2,0.6c-0.6,0.3-2,1.4-1.7-0.1c-0.9-0.1-1.5-0.9-2.3-1.1c0.2-0.1,0.3-0.3,0.5-0.5c-0.9-0.4-3.3-0.1-2.3-1.4
			c-0.6,0.4-1.4,0.6-2,0c-0.6,0.8-1.8,0.4-2.7,0.6c-0.5,0.1-0.5,0.6-0.8,0.7c-0.6,0.1-1.3-0.2-2-0.3c-0.6,0-1.4,0-2-0.1
			c-0.3,0-0.6-0.4-1-0.3c-0.1,0-0.3,0.4-0.5,0.4c-1.3,0.1-2.3,0.5-3.6,0.7c-0.6-1.5-1.3-1-2.8-1.1c-1.2-1.9-2.6-0.6-4.2-0.4
			c-0.7,0.1-0.9-0.2-1.7,0.1c-0.4,0.2-0.6,0.7-1.1,0.8c-1.2,0.3-1.3-0.3-2.1-1c-0.2-0.2-0.8-0.5-1-0.7c-0.3-0.2-0.2-0.6-0.7-0.9
			c-0.6-0.3-1.5,0.2-2-0.1c-0.5-0.2-0.4-0.7-0.8-0.9c-0.9-0.5-1.1-0.4-2.2-0.4c0,0-0.2-0.5-0.5-0.4c-0.1,0-0.3,0.1-0.4,0.2v0
			c-0.8,0.2-1.8,0.3-2.4,0.6c-0.8,0.4-1.1,1.1-2.1,1.4c-0.9,0.2-2.1-0.3-3.1-0.3c-1.8,0-3.7,0.5-5.2-0.7c-1.5-1.3-1.3-2.2-3.8-2.5
			c-1-0.2-2.2-0.2-3,0c-0.5,0.1-0.8,0.7-1.5,0.8c-1.1,0.2-2.4-0.4-3.5-0.4c-1.9,0-5.8-2.4-6.7-2.4c-0.9,0-0.8,0.5-1,0.7
			c-0.5-1.8-2.6,3.5-5.2,2.3c-2.5-1.2-2.7,2.3-4.1,2.2c-0.6-0.1-1.5-0.8-2-0.7c-0.7,0.2-1,1.4-1.5,1.5c-1.6,0.6-0.9-0.3-2.2-0.8
			c-0.7-0.3-3.5-0.5-4.1-0.4c-0.8-0.4-1.7-0.5-2.6-0.6c-0.3,0-0.7,0.5-1.2,0.4c-0.4,0-0.8-0.5-1.2-0.5c-0.5,0-1.2-0.2-1.9-0.2
			c0,0,0,0,0,0c-0.2,0-0.4,0-0.6,0c-0.3,0-0.5,0.1-0.7,0.2c-1,0.5-1.1,1.6-2.5,1.9c-0.9-1.7-1.4-0.6-2.2-0.9c-0.2-0.1-1.5-0.7-1.7-0.7
			c-1.4-0.4-2.9-1.4-4.2,0.2c-0.9-0.5-1-1.5-1.2-2.3c-1.8-0.4-2.6,1.3-4.4,0.8c0-0.1,0.1-0.3,0.1-0.4c-1.3-0.5-7.2,1-6.1-0.8
			c-0.8-0.6-1.3,0.1-1.9-0.1c-0.3-0.1-1.7-0.7-1.8-0.7c-1.1-0.1-2.4,0.5-3.5,0.6c-1.6,0.1-3.8-0.9-5.4-0.4c-1.6,0.4-1.7,1.7-2.5,2.5
			c0.6-0.8-0.4-2.3-1.8-1.9c-0.1-0.3-0.6-0.7-0.7-0.9c-1.5,0.9-1.5,2.6-2.5,3.7c-0.8,1-3.4,2.2-4.8,2.9c-1.2,0.7-1.3,0.9-2,1.6
			c-0.9,1-0.1,1.2-1.6,1.3c-1.7,0.1-1.5-1-2.5-1.2c-1-0.2-1.9,0.4-2.9,0c0.4-1.3-0.3-3.1-1.9-1.8c-0.3-0.3-0.9-0.6-1.2-0.9
			c-0.1,0.8-1.6,3.4-2.6,3.7c-0.9-2.3-2.7,0.2-4.2,0.6c-1.3,0.4-2.9,0.7-3.8,1.2c-0.8,0.4-3.4,0.9-3.8,1.6c-0.2-0.3-0.7-0.6-0.8-0.9
			c-0.9,0.5-1.5,1.1-2.5,1.7c-1.4,0.8-3.3,0.5-4.6,1.2c-1.4,0.8-0.7,2.3-2.9,1c-0.8-0.5-1.2-0.9-1.3-1.8c-1.8,1.4-2-0.9-3.2-1.6
			c0.4,0.3-2.9-0.5-2.5-0.5c-1,0-1.8-0.2-2.7,0.4c-0.1-0.9-1.1-1.2-1.9-1.5c0.3-0.4,0.4-1,0.6-1.3c-2.8,0-5.1,3-7.6,2.4
			c0.1,0.2,0.3,0.4,0.3,0.6c-1.4,0.4-4.8-2-5.7-1.9c-1,0-0.1,1.6-1.3,2.6c-0.8,0.6-1.4,1-2.1,1c-1.4,0.1-1.9,0.8-3.4,1.3
			c-1.5,0.5-2.8,0.5-4.1,0.6c-2.7,0.3-2.3-1.2-4.8-1.8c-2.5-0.5-3.3,1.7-5.1,2.1c-2.1,0.5-2-2.6-2.5-2.9c-1.9-1-3.7,1-5.2,1.2
			c-1.7,0.2-3.1-1.2-4.8-0.7c-3.5-0.8-1.5,1.1-4.4,1.1c-0.9,2-1.7,2.2-2.9,1.8c-2.1-0.7-2.4,0.3-4.1,0.1c-1.3-0.1-1.4-1.3-3.1-1.1
			c-0.7,0.1-2.1,1-2.3,1.5c-0.8-0.1-1.3-0.1-2.1,0.2c0.2-1.3-1.8-1.8-2.3-2.9c0.2-0.3,0.2-0.4,0.3-0.6c-0.6,0.2-1.4,0.3-2.1,0.1
			c-0.8,0.5-1.8,0.6-2.7,1.1c-0.1-0.1-0.2-0.2-0.3-0.4c-0.4,0.3-1.2,0.5-1.5,1C21.1,31.1,21,31,21,30.8c-0.9,0.5-1.8,0.4-2.2-0.5
			c-0.4,0.2-1.3,0.3-1.6,0.4c-0.8-2.2-1.8-3.4-4.7-2.1C11,27.1,6.8,31.6,6.2,28c-0.6,0.3-1.3,0.1-1.9,0.2c1.1-1.5-2.1-1.6-3-2.3
			c-0.2,0.1-0.5,0.2-0.7,0.3c-0.1-0.2-0.5-0.5-0.7-0.6v23.7l500.4,0V9.2z"/>

</svg>
}

